import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons'

export default function Footer() {
  return (
    <footer className="container mx-auto py-5 px-5 md:px-0 md:py-10">
      <div className="flex flex-col justify-center items-center text-white">
        <div className="mb-4">
          <h2 className="uppercase text-2xl font-josefin-sans">
            Sara Fontoura
          </h2>
          <p className="font-lato">© Todos os direitos reservados.</p>
        </div>
        <div>
          <a
            aria-label="Link do Instagram"
            className="text-white font-lato text-xl mr-2"
            href="https://www.instagram.com/sarafontoura_/"
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a
            aria-label="Número do Whatsapp"
            className="text-white font-lato text-xl"
            href="https://wa.me/351964467037"
          >
            <FontAwesomeIcon icon={faWhatsapp} />
          </a>
        </div>
      </div>
    </footer>
  )
}